import {Card} from 'external/react'
import ClientsTable from './ClientsTable'


const ClientsPage = () => {
	return (
		<Card.Body>
			<ClientsTable />
		</Card.Body>
  )
}

export {ClientsPage as default}